// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Pagination-module--wrapper--2MW_y","link":"Pagination-module--link--JKIcY"};